export const BaseUrl2 = `https://jabcomp.gy/ticket`